export default (() => {
  if (window.I18n && window.I18n.locale) {
    return window.I18n.locale;
  }
  throw new Error('No I18n or I18n.locale found');
});